import { NJLink } from '@engie-group/fluid-design-system-react';
import { Flex } from 'antd';
import './Footer.css';
//import ModelSelector from '../ModelSelector';
import ModalTermsConditions from '../ModalTermsConditions';
import ModalTickets from '../ModalTickets';
import { useState } from 'react';


function Footer({ dashboard }) {

    const [isOpenTermsConditions, setIsOpenTermsConditions] = useState(false);
   const [isOpenTickets, setIsOpenTickets] = useState(false);

    return (
        <>
            <ModalTermsConditions
                isOpen={isOpenTermsConditions}
                handleClose={() => setIsOpenTermsConditions(false)}
            />
             <ModalTickets
                isOpen={isOpenTickets}
                handleClose={() => setIsOpenTickets(false)}
            />
            <Flex justify='space-between' gap={16} className={`footer-container ${dashboard && 'footer-dashboard'}`} align='center' >

                <Flex justify='flex-start' gap={16} align='center' >
                    <NJLink
                        externalLabel="Open in a new tab"
                        href="#"
                        variant="contextual"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsOpenTermsConditions(true);
                        }
                        }
                    >
                        Terms and Conditions
                    </NJLink>
                    <NJLink
                        externalLabel="Open in a new tab"
                        href="#"
                        variant="contextual"    
                        onClick={(e) => {
                            e.preventDefault();
                            setIsOpenTickets(true);
                        }
                        }                    
                    >
                        Tickets
                    </NJLink>
                </Flex> 
                <div>
                    {/*   <ModelSelector />*/}
                </div>
                <div className='footer-text'>
                    © ENGIE 2026
                </div>
            </Flex >
        </>
    )
}

export default Footer;